import './App.css';
import Flow from "./components/Flow";
import {FlowContextProvider} from "./context/FlowContext";

function App() {
    return (
        <div className="App flow-box">
            <FlowContextProvider>
                <Flow/>
            </FlowContextProvider>
        </div>
    );
}

export default App;
